module.exports = __webpack_public_path__ + "static/media/5.8ba0d8bf.jpg";